import { useState } from 'react';

import useOnclickOutside from 'react-cool-onclickoutside';

import SkillData from '../../../types/skillData';
import IconButton from '../../atoms/button/IconButton';
import Input from '../../atoms/input';
import Card from '../../organisms/Card';

import './DeleteModal.scss';

export interface DeleteModalProps {
  skill: SkillData;
  onDelete?: () => void;
  onClose?: () => void;
}

export default function DeleteModal({ skill, onDelete, onClose }: DeleteModalProps) {
  const [typedSkillName, setTypedSkillName] = useState('');

  const ref = useOnclickOutside(
    () => {
      onClose?.();
    },
    { eventTypes: ['mouseup'] }
  );

  function handleDelete() {
    if (onDelete && onClose) {
      onDelete();
      onClose();
    }
  }

  return (
    <div className="delete-modal">
      <Card className="modal-card" innerRef={ref}>
        <div className="flex items-center justify-between mb-6">
          <h1 className="strong-heading">Delete Skill?</h1>
          <IconButton className="close-button" icon="close" visualType="no-bg" onClick={onClose} />
        </div>
        <p className="mb-8">
          Are you sure you would like to delete <span className="font-bold">{skill.name}?</span>
        </p>
        <p className="text-red secondary-heading">Warning! You cannot undo this action!</p>
        <p className="mb-4">
          Please enter <span className="font-bold">{skill.name}</span> below to confirm deletion.
        </p>
        <Input className="mb-4" state={[typedSkillName, setTypedSkillName]} />
        <IconButton
          icon="delete-forever-outline"
          label="Yes, delete forever"
          visualType="danger"
          onClick={handleDelete}
          disabled={typedSkillName.toLowerCase() !== skill.name.toLowerCase()}
        />
      </Card>
    </div>
  );
}
